import React,{useState,useEffect} from "react";

const Skill = (props) =>{

    const [percentage,setPercentage] = useState(0);

    useEffect(()=>{
        if (percentage < props.percentage){
            setTimeout(function(){ setPercentage(percentage+2)}, 35);
        }
    },[percentage]);

    return (
        <div className="skill-item">
            <div className="skill"><img src={props.icon} alt={props.title} className="skill-icon" /> <h5>{props.title}</h5></div>
            <div className="progressbar" title={props.percentage+"%"}>
                <div className="progressbar-fill" style={{width:percentage+"%"}}></div>
            </div>
        </div>
    )
}

export default Skill;